type BetweenParams = {
  min: number
  max: number
  minSelected: number
  maxSelected: number
}

export const between = ({
  min,
  max,
  minSelected,
  maxSelected,
}: BetweenParams) => {
  return minSelected < max && maxSelected > min
}
